import { getImageFromServer } from "./get-image-from-server"

export const getFileFromServer = (fileUrl: string) => {
    return getImageFromServer(fileUrl);
}